"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const {
    ref: subheadRef,
    isVisible: subheadVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="fixed inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1500413/img/freight_convoy_highway.png)]" aria-hidden="true" />

      {}
      <div className="fixed inset-0 bg-dark-background/70" aria-hidden="true" />

      {}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {}
        <div ref={headlineRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark leading-tight mb-6">
            Freight That Moves On Time, Every Time
          </h1>
        </div>

        {}
        <div ref={subheadRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-150 ${subheadVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          <p className="text-xl md:text-2xl text-foreground-dark/90 mb-10 max-w-3xl mx-auto">
            MANAGEMENT 101 LLC delivers reliable freight transportation arrangement services, coordinating every shipment with precision and care.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          <Button asChild size="lg" className="motion-safe:transition-transform motion-safe:duration-[120ms] motion-safe:ease-out motion-safe:hover:scale-[1.02] text-lg px-8 py-6 shadow-strong">
            <Link to="#contact">Get Started Today</Link>
          </Button>
        </div>
      </div>
    </section>;
}